/** @jsx jsx */
import { jsx } from 'theme-ui'
import { cf2imgix } from '../utils/cf2imgix'
import { Container } from './container'
import { AwardLabel } from './winners/moreInfoConfig'

const ArticleCards = ({
  image = '//images.ctfassets.net/n36b8lzdmgnp/6MfvlSVKOl3iB1xQcW7b57/0ecfe7563af3d291b24d879b6868cf63/Image.png',
  href = 'https://uswitch.com',
  date,
  title = 'We review award winning experiences for gaming',
  description = 'Lorem ipsum dolor sit amet, consectetur adipiscing elit. In ut sapien vitae eros tempus scelerisque. Quisque porta libero eget metus molestie auctor'
}) => (
  <a
    href={href}
    sx={{
      background: 'white',
      borderRadius: 8,
      display: 'flex',
      flexDirection: 'column',
      maxWidth: 382,
      boxShadow: '0px 8px 24px rgba(20, 20, 20, 0.08)',
      overflow: 'hidden',
      transition: 'all 0.2s ease',
      wordBreak: 'break-word',
      mb: [16, 16, 0],
      pb: 24,
      '&:hover': {
        cursor: 'pointer',
        boxShadow: '0px 4px 12px rgba(20, 20, 20, 0.16)',
        transform: 'translateY(2px)',
        '&:hover h5': {
          textDecoration: 'underline'
        }
      }
    }}
  >
    <img alt={title} src={cf2imgix(image)} />
    <div sx={{ px: 16 }}>
      {date && (
        <p
          sx={{
            color: '#8C8C8C',
            fontWeight: 400,
            fontSize: 14,
            lineHeight: '20px',
            mt: 24,
            mb: '8px'
          }}
        >
          {date}
        </p>
      )}
      <h5
        sx={{
          fontWeight: 800,
          fontSize: '24px',
          lineHeight: '32px',
          color: '#141414',
          mb: 16,
          textDecoration: 'underline'
        }}
      >
        {title}
      </h5>
      <p
        sx={{
          fontSize: '14px',
          lineHeight: '24px',
          color: '#8C8C8C',
          m: 0
        }}
      >
        {description}
      </p>
    </div>
  </a>
)

const Articles = () => (
  <section>
    <Container>
      <h2
        sx={{
          textAlign: 'center',
          color: 'primary',
          fontSize: ['36px', '42px'],
          pt: [48, 64],
          pb: [32, 48],
          m: 0
        }}
      >
        Related articles
      </h2>
      <div
        sx={{
          display: 'flex',
          justifyContent: 'center',
          flexWrap: 'wrap',
          gap: 48,
          pb: 68
        }}
      >
        <ArticleCards
          image="//images.ctfassets.net/g836doytpz4a/7aYmKgjkF5muAw7xN4PSXr/af6cab356de1b90996854a1617908541/Broadband_awards_2024_news_piece.png"
          href="https://www.uswitch.com/broadband/news/uswitch-broadband-award-winners-2024/"
          title="The 2024 Uswitch Broadband and TV Awards"
          description="Uswitch has announced the winners of its Broadband and TV Awards for 2024, with Plusnet, Community Fibre and Disney Plus sweeping the categories this year."
          date="07 Febuary 2024"
        />

        <ArticleCards
          image="//images.ctfassets.net/g836doytpz4a/6glFxIcEHGYeip5TyMDpQt/21905ce336b68f74777ea6a644fd3b25/Mobiles_awards_2024_news_piece.png"
          href="https://www.uswitch.com/mobiles/news/uswitch-mobiles-award-winners-2024/"
          title="The 2024 Uswitch Mobile Awards"
          description="It’s awards season! Here at Uswitch, we like to celebrate the best networks, phones, and all things telecoms from the past year. Find out the latest winners in Mobiles."
          date="07 Febuary 2024"
        />
      </div>
    </Container>
  </section>
)

export default Articles
